import { Phone, Check } from "lucide-react";
import { scrollToId } from "@/lib/scroll";
import { Reveal } from "./Reveal";
import { PHONE_TEL } from "./data";

const reassurances = [
  "Quick response",
  "Clear, upfront communication",
  "Domestic & commercial work",
];

export const CtaBand = () => (
  <section data-testid="cta-band-section" className="bg-blue-600 py-20 md:py-24">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <Reveal>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-white">
          Need an Electrician?
        </h2>
        <p className="mt-4 text-base md:text-lg leading-relaxed text-blue-100 max-w-xl">
          Tell us what you need and we'll make it easy to get the help you need.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row gap-4">
          <a
            data-testid="cta-band-call-button"
            href={PHONE_TEL}
            className="inline-flex items-center justify-center gap-2 bg-amber-400 hover:bg-amber-300 text-slate-950 font-bold px-8 py-4 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-blue-600"
          >
            <Phone className="w-4 h-4" /> Call Now
          </a>
          <button
            data-testid="cta-band-quote-button"
            onClick={() => scrollToId("contact")}
            className="inline-flex items-center justify-center gap-2 border border-white/60 hover:bg-white/10 text-white font-bold px-8 py-4 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-blue-600"
          >
            Request a Quote
          </button>
        </div>
        <ul
          data-testid="cta-band-reassurances"
          className="mt-9 flex flex-wrap gap-x-7 gap-y-3"
        >
          {reassurances.map((r) => (
            <li key={r} className="flex items-center gap-2 text-sm font-semibold text-white">
              <Check className="w-4 h-4 text-amber-400" strokeWidth={3} />
              {r}
            </li>
          ))}
        </ul>
      </Reveal>
    </div>
  </section>
);

export const FinalCta = () => (
  <section data-testid="final-cta-section" className="bg-white border-t border-slate-200 py-16 md:py-20">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <Reveal className="flex flex-col md:flex-row md:items-center md:justify-between gap-8">
        <div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
            Ready to get started?
          </h2>
          <p className="mt-2.5 text-base md:text-lg text-slate-600">
            Get in touch today for a quote.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 shrink-0">
          <a
            data-testid="final-cta-call-button"
            href={PHONE_TEL}
            className="inline-flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-bold px-8 py-4 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2"
          >
            <Phone className="w-4 h-4" /> Call Now
          </a>
          <button
            data-testid="final-cta-quote-button"
            onClick={() => scrollToId("contact")}
            className="inline-flex items-center justify-center gap-2 border border-slate-300 bg-white hover:bg-slate-50 text-slate-900 font-bold px-8 py-4 rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-offset-2"
          >
            Request a Quote
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
